module.exports = __webpack_public_path__ + "img/IMG_8618_L_Black.0f5e9635.jpg";